<template>
	<div class="scadmin">
        <main>
            <span>加油油罐： </span>
            <el-select v-model="address" placeholder="请选择加油油罐" style="width:200px">
                <el-option
                    v-for="(item,i) in options"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span>领用人： </span>
            <el-input v-model="name" placeholder="驾驶员" style="display:inline-block" clearable></el-input>

            <span>领用部门：  </span>
            <el-input v-model="bumen" placeholder="领用部门" style="display:inline-block" clearable></el-input>
            <br/>
            <br/>

            <span>状态： </span>
            <el-select v-model="status" placeholder="请选择" clearable style="width:224px" >
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="拒绝" value="2"></el-option>
            </el-select>

            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-button style="margin-left:20px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>
        </main>
            
        <el-card style="border: solid #ccc 1px">
            <el-table 
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    prop="time"
                    label="领用时间">
                </el-table-column>

                <el-table-column
                    prop="gongsi2"
                    label="加油油罐">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="领用人">
                </el-table-column>

                <el-table-column
                    prop="bumen"
                    label="领用部门">
                </el-table-column>

                <el-table-column
                    prop="shengshu"
                    label="领用升数">
                </el-table-column>

                <el-table-column
                    prop="mess"
                    label="备注">
                </el-table-column>

                <el-table-column
                    width="300"
                    label="照片">
                    <template slot-scope="scope">
                        <span v-for="(item,i) in (scope.row.url).split(',')">
                            <el-popover
                                placement="bottom"
                                trigger="click">
                                <img :src="item" alt="" style="width:500px;height:500px">
                                <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference" >
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待审核</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                        <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                    </template>
                </el-table-column>

                <el-table-column label="审核" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status!=1">
                            <el-button type="text" @click="caoZuoYouKa(scope.row.id,1)">通过</el-button>
                            <el-button type="text" style="color:#F56C6C" @click="caoZuoYouKa(scope.row.id,2)">拒绝</el-button>
                            <el-button type="text" style="color:#E6A23C" @click="edit(scope.row)">修改</el-button>
                            <el-button type="text" style="color:#909399" @click="caoZuoYouKa(scope.row.id,3)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="shenpiren"
                    label="审核人">
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>        

        <el-dialog
            title="修改信息"
            :visible.sync="dialogVisible"
            width="400px">
            <el-row style="margin-bottom:10px">
                <el-col :span="6">
                    <span >领用升数</span>
                </el-col>
                <el-col :span="18">
                    <el-input style="width:100%" v-model="shengshu" ></el-input>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6">
                    <span >备注</span>
                </el-col>
                <el-col :span="18">
                    <el-input style="width:100%" v-model="mess" placeholder="备注"></el-input>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editSure()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import option from "../config/option.js"
    import { powerList,url2 } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],
                options: [],
               
                address:'',
                name:'',
                bumen:'',
                time:[],
                status:'',

                dialogVisible:false,
                id:'',
                shengshu:'',
                mess:'',
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getUser()
            await this.getList()
        },
		methods: {
            search() {
                this.current_page = 1
                this.getList()
            },

            edit(x) {
                this.id = x.id,
                this.shengshu = x.shengshu,
                this.mess = x.mess,
                this.dialogVisible = true;
            },

            editSure() {
                this.axios.get(url2+'youEdit2', {
                    params:{
                        id:this.id,
                        shengshu: this.shengshu,
                        mess: this.mess,
                    }
                }).then(res=> {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });r
                    this.getList()
                    this.dialogVisible = false;
                }).catch(err=> {
                    console.log(err);
                });
            },

            caoZuoYouKa(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2+'caozuoYouka2', {
                        params:{
                            id:x,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },

            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list  = res.data[0].you.split(',')
                    list.map(item=> {
                        this.options.push(item)
                    })
                    this.address = this.options[0]
                    if(this.address == '全部') {
                        const elementToRemove = '场外加油站'; 
                        this.options = option.you.filter(item => item !== elementToRemove);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },
            
            async getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
               
                await this.axios.get(url2+'youka2Search', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        name:this.name,
                        bumen:this.bumen,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                        status:this.status,
                    }
                }).then(res=> {
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                    loading.close();
                }).catch(err=> {
                    console.log(err);
                    loading.close();
                });
            },

            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url2+'youka2Search', {
                    params:{
                        export:1,
                        page:this.current_page,
                        per_page:this.per_page,
                        name:this.name,
                        bumen:this.bumen,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                        status:this.status,
                    },
                    responseType: 'blob',
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '下载.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

        }
    }
</script>

<style scoped="scoped" lang='less'>
    .scadmin {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .scadmin .el-input {
        width:140px;
        margin-right: 20px;
    }
    .scadmin .el-select {
        width:140px;
        margin-right: 20px;
    }
    .scadmin main {
        margin-bottom: 20px;
    }
    .scadmin .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>

